import type { TenantUiLabelProfile } from "@madamuh/domain";

export type TenantLabels = {
  lesson: string;
  teacher: string;
  studio: string;
  student: string;
  familyAccount: string;
  enrollment: string;
};

export type TenantUiCopy = {
  labels: TenantLabels;
  memberRole: {
    parent: string;
    student: string;
    teacher: string;
    admin: string;
  };
  entityType: {
    lesson: string;
    occurrence: string;
    studentScope: string;
    familyScope: string;
  };
  communicationCategory: {
    lessonSupport: string;
    occurrenceSupport: string;
    eventSupport: string;
  };
  phrase: {
    lessonList: string;
    teacherHome: string;
    studentDetail: string;
    studioUndecided: string;
    teacherUndecided: string;
    enrollmentList: string;
  };
};

const LABELS_BY_PROFILE: Record<TenantUiLabelProfile, TenantLabels> = {
  dance: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "スタジオ",
    student: "生徒",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  genericLesson: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "会場",
    student: "受講者",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  sports: {
    lesson: "クラス",
    teacher: "コーチ",
    studio: "会場",
    student: "参加者",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  music: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "教室",
    student: "生徒",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  academic: {
    lesson: "授業",
    teacher: "講師",
    studio: "教室",
    student: "受講者",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  art: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "アトリエ",
    student: "生徒",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  }
};

export const GENERIC_TENANT_LABELS: TenantLabels = LABELS_BY_PROFILE.genericLesson;

export function getTenantLabels(profile: TenantUiLabelProfile): TenantLabels {
  return LABELS_BY_PROFILE[profile];
}

export function buildTenantUiCopy(labels: TenantLabels): TenantUiCopy {
  return {
    labels,
    memberRole: {
      parent: "保護者",
      student: `${labels.student}本人`,
      teacher: labels.teacher,
      admin: "管理者"
    },
    entityType: {
      lesson: labels.lesson,
      occurrence: `${labels.lesson}予定`,
      studentScope: `${labels.student}ごと`,
      familyScope: "家族単位"
    },
    communicationCategory: {
      lessonSupport: `${labels.lesson}補助`,
      occurrenceSupport: `${labels.lesson}予定補助`,
      eventSupport: "イベント補助"
    },
    phrase: {
      lessonList: `${labels.lesson}一覧`,
      teacherHome: `${labels.teacher}ホーム`,
      studentDetail: `${labels.student}詳細`,
      studioUndecided: `${labels.studio}未定`,
      teacherUndecided: `${labels.teacher}未定`,
      enrollmentList: `${labels.enrollment}一覧`
    }
  };
}

export function getTenantUiCopy(profile: TenantUiLabelProfile): TenantUiCopy {
  return buildTenantUiCopy(getTenantLabels(profile));
}
